/** Where a login that started from a device pairing page should land.
    Returns null when the login did not come from one. */
export function connectTarget(search) {
  const params = new URLSearchParams(search);
  const next = params.get('next');
  if (next !== 'connect') return null;
  const query = new URLSearchParams();
  for (const key of ['client', 'code']) if (params.get(key)) query.set(key, params.get(key));
  const qs = query.toString();
  return qs ? `/connect?${qs}` : '/connect';
}
